import $axios from "../api/accessor";
import { $api } from "../api/api";

export const adminLogin = async (payload: any) => {
  try {
    const response = await $axios.post($api("login"), payload);
    return response;
  } catch (error: any) {
    throw error.response ? error.response.data : error.message;
  }
};

export const adminLogout = async () => {
  return await $axios.post($api("logout"));
};
